import(/* webpackMode: "eager" */ "/home/administrator/single_repo/gov-portal-framework/apps/central_client/src/app/news/page.tsx");
